import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import {
  Typography,
  Row,
  Col,
  Form,
  Table,
  Input,
  DatePicker,
  InputNumber,
  Modal,
  Icon,
  Button,
  Select,
  Avatar,
  message,
  Checkbox
} from "antd";
import {
  LoadingOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  SaveOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { alertMessage } from "../../../../../../utils/message";
import FromInput from "../../../../../../components/user/from/Input";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import moment from "moment";
import { numberWithCommas } from "../../../../../../utils/number";
import { checkLinkURL } from "../../../../../../utils/auth";
import ModalshowAllImageBase64 from "../../../../../../components/user/ModalshowAllImage/newsBase64";
import { Span } from "../../../../../../components/element";
import axiosAPI, { urlAttachFile } from "../../../../../../config/axiosAPI";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
class WelfareListStudyPaymentInPaymentDetail extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    dataAttachInvoice: [],
    ModalshowAllImageVisible: false,
    ModalshowAllImageTitle: null,
    ModalshowAllImageData: [],
    ModalshowAllImageArrayId: null,
    ModalshowAllImageDatabase: true,
    summaryStudyFeeDetailPrice: null,
    summaryStudyFeeDetailActualPrice: null,
    inputNumberOnBlur: false,
    dropdownExpense:[],
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "noTable",
        width: "30px",
        align: "center",
        render: (item, record, index) => <span>{index + 1}</span>,
      },
      {
        title: <Span req>ประเภทการเบิก</Span>,
        dataIndex: "studyFeeDetailExpenses",
        width: "220px",
        align: "center",
        render: (item, record, index) => (
          <>
          <Form.Item style={{ marginBottom: "0px" }}>
                {this.props.form.getFieldDecorator( `studyEducationFeeDetail[${index}].studyFeeDetailExpenses`, {
                  initialValue: item
                    ? item
                    : "term_fee",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาเลือกประเภทการเบิก",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                    disabled={
                      this.props.isViewOnly
                        ? true
                        : record.disabledRow
                        ? true
                        : false
                    }
                    showSearch
                    placeholder="กรุณาเลือก ประเภทการเบิก"
                    optionFilterProp="children"
                    // onChange={(value) =>
                    //   this.handleChangeSelectDisasterType(value)
                    // }
                  >
                    {console.log(
                      "dropdownExpense select",
                      this.state.dropdownExpense
                    )}
                    {this.state.dropdownExpense.map(
                      (valuesLabel, keys) => {
                        return (
                          <Option value={valuesLabel.dropDownValueTh}>
                            {valuesLabel.dropDownNameTh}
                          </Option>
                        );
                      }
                    )}
                  </Select>
                )}
              </Form.Item>

            {/* <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeAttachment[0].studyFeeAttachmentSort`,
                {
                  initialValue: record.studyEducationFeeAttachfile[0]
                    ?.studyFeeAttachmentSort
                    ? record.studyEducationFeeAttachfile[0]
                        ?.studyFeeAttachmentSort
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item> */}

            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].isDeleted`,
                {
                  initialValue: record.isDeleted ? record.isDeleted : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailRemark`,
                {
                  initialValue: record.studyFeeDetailRemark
                    ? record.studyFeeDetailRemark
                    : "-",
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>

            {/* <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeAttachment[0].isDeleted`,
                {
                  initialValue: record.studyEducationFeeAttachfile[0]?.isDeleted
                    ? record.studyEducationFeeAttachfile[0]?.isDeleted
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item> */}
            {record.studyEducationFeeDetailId && (
              <Form.Item className="mb-0" hidden>
                {this.props.form.getFieldDecorator(
                  `studyEducationFeeDetail[${index}].studyEducationFeeDetailId`,
                  {
                    initialValue: record.studyEducationFeeDetailId
                      ? record.studyEducationFeeDetailId
                      : "-",
                    rules: [
                      {
                        required: false,
                        message: "กรุณาระบุ รายละเอียด",
                      },
                    ],
                  }
                )(
                  <Input
                    className="w-100"
                    placeholder="ระบุ รายละเอียด"
                    disabled={this.props.isViewOnly}
                    allowClear={false}
                  />
                )}
              </Form.Item>
            )}
          </>
        ),
      },
            {
        title: <Span req>สถานศึกษา</Span>,
        dataIndex: "studyFeeDetailSchool",
        width: "220px",
        align: "center",
        render: (item, record, index) => (
          <>
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={true}
                  value={this.props.form.getFieldsValue()?.studyEducationFeeDetail[index].studyFeeDetailExpenses ? this.props.form.getFieldsValue()?.studyEducationFeeDetail[index].studyFeeDetailExpenses === 'term_fee' ? this.props.rawData?.studyLeaveDetails[0]?.studyLeaveAcademy : '-' : ''}
                />
                 </>
              )
          
            },

      {
        title: <Span req>รายละเอียด</Span>,
        dataIndex: "studyFeeDetailDescription",
        width: "220px",
        align: "center",
        render: (item, record, index) => (
          <>
            <Form.Item className="mb-0">
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailDescription`,
                {
                  initialValue: item ? item : "",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={
                    this.props.isViewOnly
                      ? true
                      : record.disabledRow
                      ? true
                      : false
                  }
                  allowClear={false}
                />
              )}
            </Form.Item>
            {/* <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeAttachment[0].studyFeeAttachmentSort`,
                {
                  initialValue: record.studyEducationFeeAttachfile[0]
                    ?.studyFeeAttachmentSort
                    ? record.studyEducationFeeAttachfile[0]
                        ?.studyFeeAttachmentSort
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item> */}

            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].isDeleted`,
                {
                  initialValue: record.isDeleted ? record.isDeleted : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailRemark`,
                {
                  initialValue: record.studyFeeDetailRemark
                    ? record.studyFeeDetailRemark
                    : "-",
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>

            {/* <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeAttachment[0].isDeleted`,
                {
                  initialValue: record.studyEducationFeeAttachfile[0]?.isDeleted
                    ? record.studyEducationFeeAttachfile[0]?.isDeleted
                    : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item> */}
            {record.studyEducationFeeDetailId && (
              <Form.Item className="mb-0" hidden>
                {this.props.form.getFieldDecorator(
                  `studyEducationFeeDetail[${index}].studyEducationFeeDetailId`,
                  {
                    initialValue: record.studyEducationFeeDetailId
                      ? record.studyEducationFeeDetailId
                      : "-",
                    rules: [
                      {
                        required: false,
                        message: "กรุณาระบุ รายละเอียด",
                      },
                    ],
                  }
                )(
                  <Input
                    className="w-100"
                    placeholder="ระบุ รายละเอียด"
                    disabled={this.props.isViewOnly}
                    allowClear={false}
                  />
                )}
              </Form.Item>
            )}
            {record.studyEducationFeeAttachfile?.studyFeeAttachmentId && (
              <>
                {/* <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetail[${index}].studyFeeAttachmentId`,
                    {
                      initialValue: record.studyFeeAttachmentId
                        ? record.studyFeeAttachmentId
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item> */}
                {/* <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetail[${index}].studyFeeAttachment[0].studyFeefileType`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        ?.studyFeefileType
                        ? record.studyEducationFeeAttachfile[0]
                            ?.studyFeefileType
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item> */}
                {/* <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetail[${index}].studyFeeAttachment[0].studyFeefileName`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        ?.studyFeefileName
                        ? record.studyEducationFeeAttachfile[0]
                            ?.studyFeefileName
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item> */}
                {/* <Form.Item className="mb-0" hidden>
                  {this.props.form.getFieldDecorator(
                    `studyEducationFeeDetail[${index}].studyFeeAttachment[0].studyFeefilePath`,
                    {
                      initialValue: record.studyEducationFeeAttachfile[0]
                        ?.studyFeefilePath
                        ? record.studyEducationFeeAttachfile[0]
                            ?.studyFeefilePath
                        : "-",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุ รายละเอียด",
                        },
                      ],
                    }
                  )(
                    <Input
                      className="w-100"
                      placeholder="ระบุ รายละเอียด"
                      disabled={this.props.isViewOnly}
                      allowClear={false}
                    />
                  )}
                </Form.Item> */}
              </>
            )}

            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailType`,
                {
                  initialValue: record.studyFeeDetailType
                    ? record.studyFeeDetailType
                    : "INVOICE",
                  rules: [
                    {
                      required: true,
                      message: "กรุณาระบุ รายละเอียด",
                    },
                  ],
                }
              )(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
            <Form.Item
              hidden
              name={["studyEducationFeeDetail", index, "disabledRow"]}
              label={""}
              initialValue={item ? item : false}
            >
              <Input hidden />
            </Form.Item>
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].isValidate`,
                {
                  initialValue: item ? item : false,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                }
              )(<Input hidden />)}
            </Form.Item>

            <Form.Item
              hidden
              name={["studyEducationFeeDetail", index, "isValidate"]}
              label={""}
              initialValue={item ? item : false}
            >
              <Input hidden />
            </Form.Item>
            <Form.Item
              name={["studyEducationFeeDetail", index, "isShowEditButton"]}
              initialValue={item ? item : false}
              hidden
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["studyEducationFeeDetail", index, "isShowSaveButton"]}
              initialValue={item ? item : false}
              hidden
            >
              <Input />
            </Form.Item>
          </>
        ),
      },
      {
        title: "เลขที่ใบเสร็จ",
        dataIndex: "studyFeeDetailInvoiceNo",
        width: "200px",
        align: "center",
        render: (item, record, index) => (
          <Form.Item className="mb-0">
            {this.props.form.getFieldDecorator(
              `studyEducationFeeDetail[${index}].studyFeeDetailInvoiceNo`,
              {
                initialValue: item ? item : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ เลขที่ใบเสร็จ",
                  },
                ],
              }
            )(
              <Input
                className="w-100"
                placeholder="ระบุ เลขที่ใบเสร็จ"
                disabled={
                  this.props.isViewOnly
                    ? true
                    : record.disabledRow
                    ? true
                    : false
                }
                allowClear={false}
              />
            )}
          </Form.Item>
        ),
      },
      {
        title: <Span req>วันที่ในใบเสร็จ</Span>,
        dataIndex: "studyFeeDetailSlipDate",
        width: "200px",
        align: "center",
        render: (item, record, index) => (
          <Form.Item className="mb-0">
            {this.props.form.getFieldDecorator(
              `studyEducationFeeDetail[${index}].studyFeeDetailSlipDate`,
              {
                initialValue: item ? moment(item) : null,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ วันที่ในใบเสร็จ",
                  },
                ],
              }
            )(
              <DatePicker
                disabledDate={this.disabledSlipDate}
                disabled={
                  this.props.isViewOnly
                    ? true
                    : record.disabledRow
                    ? true
                    : false
                }
                format={this.dateFormatNumber(
                  `studyEducationFeeDetail[${index}].studyFeeDetailSlipDate`
                )}
                className="w-100"
                placeholder="เลือกวันที่"
                allowClear={false}
              />
            )}
          </Form.Item>
        ),
      },
      {
        title: <Span req>จำนวนเงินในใบเสร็จ (บาท)</Span>,
        dataIndex: "studyFeeDetailPrice",
        width: 200,
        align: "center",
        render: (item, record, index) => (
          <Form.Item className="mb-0">
            {this.props.form.getFieldDecorator(
              `studyEducationFeeDetail[${index}].studyFeeDetailPrice`,
              {
                initialValue: item ? item : 0,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ จำนวนเงินในใบเสร็จ (บาท)",
                  },
                ],
              }
            )(
              <InputNumber
                step={1000.01}
                min={0.0}
                disabled={
                  this.props.isViewOnly
                    ? true
                    : record.disabledRow
                    ? true
                    : false
                }
                formatter={(item) => item.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                className="input-number"
                onBlur={(e) => this.handleChangeWithdrawTotal(e, index)}
              />
            )}
          </Form.Item>
        ),
      },
      {
        title: <Span req>จำนวนเงินที่เบิกได้ (บาท)</Span>,
        dataIndex: "studyFeeDetailActualPrice",
        width: "200px",
        align: "center",
        render: (item, record, index) => (
          <>
            <Form.Item className="mb-0">
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailActualPrice`,
                {
                  initialValue: item ? item : 0,
                  rules: [
                    {
                      required: true,
                      message: "กรุณาระบุ จำนวนเงินที่เบิกได้ทั้งหมด (บาท)",
                    },
                  ],
                }
              )(
                <InputNumber
                  // defaultValue={item}
                  step={1000.01}
                  min={0.0}
                  //max={this.state.disasterCondition}
                  disabled={
                    this.props.isViewOnly
                      ? true
                      : record.disabledRow
                      ? true
                      : false
                  }
                  formatter={(item) =>
                    `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                  //onBlur={(value) => this.handleChangeWithdraw(value)}
                  className="input-number"
                  onBlur={(value) => this.handleChangeWithdraw(value, index)}
                />
              )}
            </Form.Item>
            {/* <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator(
                `studyEducationFeeDetail[${index}].studyFeeDetailPrice`,
                {
                  initialValue: item ? item : 0,
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ จำนวนเงินที่เบิกได้ทั้งหมด (บาท)",
                    },
                  ],
                }
              )(
                <InputNumber
                  // defaultValue={item}
                  step={1000.01}
                  min={0.0}
                  //max={this.state.disasterCondition}
                  disabled={
                    this.props.isViewOnly
                      ? true
                      : record.disabledRow
                      ? true
                      : false
                  }
                  formatter={(item) =>
                    `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                  //onBlur={(value) => this.handleChangeWithdraw(value)}
                  className="input-number"
                />
              )}
            </Form.Item> */}
          </>
        ),
      },
      {
        title: <Span req>แนบใบเสร็จ</Span>,
        dataIndex: "studyEducationFeeAttachfile",
        align: "center",
        width: "200px",
        render: (item, record, index) => {
          // record.studyEducationFeeAttachfile[0]?.studyFeeAttachmentId &&
          // record.studyEducationFeeAttachfile[0]?.studyFeefileName
          //   ? this.showMoreFileUploads(
          //       index,
          //       record.studyEducationFeeAttachfile[0]
          //     )
          //   : this.inputFormUploads(index, record),
          return (
            <>
              {!this.props.isViewOnly &&
                this.inputFormUploads(index, item, record)}
              {this.showMoreFileUploads(
                index,
                record.studyEducationFeeAttachfile
              )}
            </>
          );
        },
      },
      {
        title: "จัดการ",
        dataIndex: "orgTable",
        width: "120px",
        align: "center",
        render: (item, record, index) => {
          return this.showDetailBtnInput(
            record,
            index,
            record.studyEducationFeeDetailId
          );
        },
      },
    ],
  };

  disabledSlipDate = (current) => {
    const { submitDateValue } = this.state;
    const { formRef } = this.props;

    // let dateSubmit = new Date(formRef.current.getFieldsValue().studyEducationFee.submitDate)

    let date = new Date(submitDateValue);
    // let dateSubmitSubtract = moment(
    //   new Date(submitDateValue).setFullYear(
    //     new Date(submitDateValue).getFullYear() - 1
    //   )
    // );
    let dateSubmitSubtract = moment(submitDateValue)
  .subtract(1, 'year')
  .add(1, 'day')
  .startOf('day');

    //console.log("dateSubmit", dateSubmit);
    console.log("submitDateValue", submitDateValue);
    console.log("dateSubmitSubtract -1", dateSubmitSubtract);

    console.log("moment date ", date);

    let date2 = moment(date.setDate(date.getDate() + 1));
    console.log("moment +1", date2);
    return current > date || current < dateSubmitSubtract
  };

  handleChangeWithdrawTotal = (e, arrayId) => {
    const { form } = this.props;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetail } = fields;

    const studyFeeDetailPrice =
      studyEducationFeeDetail[arrayId].studyFeeDetailPrice;
    const studyFeeDetailActualPrice =
      studyEducationFeeDetail[arrayId].studyFeeDetailActualPrice;

    if (studyFeeDetailPrice > studyFeeDetailActualPrice) {
      Object.assign(studyEducationFeeDetail[arrayId], {
        studyFeeDetailActualPrice: studyFeeDetailPrice,
      });
      form.setFieldsValue({ studyEducationFeeDetail });
    }

    // Object.assign(studyEducationFeeDetail[arrayId], {
    //   studyFeeDetailActualPrice:
    //     studyEducationFeeDetail[arrayId].studyFeeDetailPrice,
    // });
    // form.setFieldsValue({ studyEducationFeeDetail });
  };

  handleChangeWithdraw = (value, arrayId) => {
    const { form } = this.props;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetail } = fields;

    if (
      studyEducationFeeDetail[arrayId].studyFeeDetailPrice <
      studyEducationFeeDetail[arrayId].studyFeeDetailActualPrice
    ) {
      alertMessage("error", "จำนวนเงินที่เบิก มากกว่า จำนวนเงินใบเสร็จ");
      Object.assign(studyEducationFeeDetail[arrayId], {
        studyFeeDetailActualPrice:
          studyEducationFeeDetail[arrayId].studyFeeDetailPrice,
      });
      form.setFieldsValue({ studyEducationFeeDetail });
    }
  };

  handleAddUploadsFile = async (images, arrayId) => {
    const { form } = this.props;
    const { dataAttachInvoice, reqAttachDayStatus } = this.state;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetail } = fields;
    let dataSourceitems = [...this.state.dataAttachInvoice];
    let item = { ...dataAttachInvoice[arrayId] };
    let arrayMap = [...images];

    console.log("item", item);
    await arrayMap.map(async (values, keys) => {
      const isLt2M = values.size / 1024 / 1024 < 20;
      if (
        values.type == "image/jpeg" ||
        values.type == "application/pdf" ||
        values.type == "image/png"
      ) {
        if (!isLt2M) {
          message.error("ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง");
        } else {
          if (item.studyEducationFeeAttachfile.length > 0) {
            item.studyEducationFeeAttachfile.map((valuesData, keys) => {
              if (valuesData.fileIdBase64) {
                item.studyEducationFeeAttachfile[0].isDeleted = 1;
                item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 0;
                item.studyEducationFeeAttachfile[1] = values;
                item.studyEducationFeeAttachfile[1].isDeleted = 0;
                item.studyEducationFeeAttachfile[1].studyFeeAttachmentSort = 1;
                item.studyEducationFeeAttachfile[1].studyFeefileName =
                  values.name;
                item.studyEducationFeeAttachfile[1].studyFeefileType =
                  values.type;
                item.studyEducationFeeAttachfile[1].studyFeefilePath = "";
              } else {
                item.studyEducationFeeAttachfile[0] = values;
                item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 1;
                item.studyEducationFeeAttachfile[0].isDeleted = 0;
                item.studyEducationFeeAttachfile[0].studyFeefileName =
                  values.name;
                item.studyEducationFeeAttachfile[0].studyFeefileType =
                  values.type;
                item.studyEducationFeeAttachfile[0].studyFeefilePath = "";
              }
            });
          } else {
            item.studyEducationFeeAttachfile[0] = values;
            item.studyEducationFeeAttachfile[0].studyFeeAttachmentSort = 0;
            item.studyEducationFeeAttachfile[0].isDeleted = 0;
            item.studyEducationFeeAttachfile[0].studyFeefileName = values.name;
            item.studyEducationFeeAttachfile[0].studyFeefileType = values.type;
            item.studyEducationFeeAttachfile[0].studyFeefilePath = "";
          }

          await form.setFieldsValue({ studyEducationFeeDetail });
          values.base64 = "";

          item = {
            //studyFeeDetailBookNo: item.studyFeeDetailBookNo,
            studyFeeDetailType: "INVOICE",
            studyFeeDetailInvoiceNo: item.studyFeeDetailInvoiceNo,
            studyFeeDetailExpenses: item.studyFeeDetailExpenses,
            studyFeeDetailSlipDate: item.studyFeeDetailSlipDate,
            studyFeeDetailPrice: item.studyFeeDetailPrice,
            studyEducationFeeAttachfile: item.studyEducationFeeAttachfile,
            studyFeeDetailActualPrice: item.studyFeeDetailActualPrice,
          };

          //  await Object.assign(studyEducationFeeDetail[arrayId],
          //     {
          //        studyEducationFeeAttachfile: item.studyEducationFeeAttachfile
          //     }
          //  )

          studyEducationFeeDetail.map((valuesData, keys) => {
            if (keys == arrayId) {
              valuesData.studyEducationFeeAttachfile =
                item.studyEducationFeeAttachfile;
            }
          });

          console.log(
            "item.studyEducationFeeAttachfile",
            studyEducationFeeDetail
          );

          await form.setFieldsValue({ studyEducationFeeDetail });

          await this.getBase64(item.studyEducationFeeAttachfile, arrayId, keys);

          await this.setState(
            {
              dataAttachInvoice: dataSourceitems,
            },
            () => {
              // document.getElementById('input-filePayments-'+arrayId).value = [];
              // this.cllBackSetValueOrganizatuions()
            }
          );
        }
      } else {
        alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf");
        // message.error('กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf');
      }
    });
  };

  getBase64 = async (file, arrayId) => {
    const { form } = this.props;
    const fields = form.getFieldsValue();
    const { studyEducationFeeDetail } = fields;

    file.map((values, keysItem) => {
      console.log("xxvaluesx", values);
      new Promise((resolve) => {
        const reader = new FileReader();
        if (values.studyFeeAttachmentId) {
          // resolve(baseURL);
        } else {
          reader.readAsDataURL(values);
          reader.onload = async () => {
            var baseURL = reader.result.split("base64,");
            console.log("baseURL", baseURL);
            await Object.assign(studyEducationFeeDetail[arrayId], {
              studyEducationFeeAttachfile: (values.base64 = baseURL[1]),
              //  studyEducationFeeAttachfile: values.studyFeefileName = baseURL[1]
              //  studyEducationFeeAttachfile: values.studyFeefileType = baseURL[1]
            });
          };
        }
      });
    });
  };
  inputFormUploads = (arrayId, item, record) => {
    const { isViewOnly } = this.props;
    const { dataAttachInvoice } = this.state;
    // let fileName = dataAttachInvoice[arrayId].studyEducationFeeAttachfile
    //   ? dataAttachInvoice[arrayId].attachFile.name
    //   : "";
    {
      console.log("item file", item);
    }
    let fileName =
      item.length == 1 && item[0].studyFeefileName
        ? item[0].studyFeefileName
        : item.length > 1 && item[1].studyFeefileName
        ? item[1].studyFeefileName
        : "";
    {
      console.log("item file fileName", fileName);
    }
    return (
      <>
        {/* <label
        for={"input-filePayments-" + arrayId}
        className="custom-file-upload"
        hidden={isViewOnly}
      >
        <p
                      className="py-2 px-4 mb-0"
                      align={"center"}
                      style={{ backgroundColor: "#8d0e14", color: "#fff" }}
                    >
          อัปโหลด +
        </p>
        <p style={{ fontSize: "12px" }} className="my-2">
          แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
        </p>
      </label> */}
        {/* <Form.Item valuePropName="fileList" className="height-input-menu">
            {this.props.form.getFieldDecorator(
              `studyEducationFeeDetail[${arrayId}].file`,
              {
                // initialValue: item ? item : "",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ รายละเอียด",
                  },
                ],
              }
            )(
              <input
              id={"input-filePayments-"+arrayId}
              className="input-file"
              multiple
              // name={uploadName}
              type="file"
              accept="file_extension"
              // rules={ true }
              onChange={(e) => this.handleAddUploadsFile(e.target.files, arrayId)}
              accept="image/png, image/jpeg, application/pdf"
              // onChange={e => console.log(e.target.studyEducationFeeAttachfiles)}
              style={{ height:"0px" }}
              disabled={ this.props.isViewOnly ? true : record.disabledRow ? true : false}
           />
       
            )}
          </Form.Item> */}

        {/* <Form.Item valuePropName="fileList" className="height-input-menu" hidden>
            {this.props.form.getFieldDecorator(
              `studyEducationFeeDetail[${arrayId}].studyEducationFeeAttachfile`,
              {
                initialValue: item ? item : "",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ รายละเอียด",
                  },
                ],
              }
            )(
           
<Input/>
            
        
            )}
          </Form.Item> */}

        <Form.Item label={""} style={{ marginBottom: "0px" }}>
          {this.props.form.getFieldDecorator(
            `studyEducationFeeDetail[${arrayId}].studyEducationFeeAttachfile`,
            {
              initialValue: item ? item : null,
              // valuePropName: "fileList",
              // rules: [
              //   {
              //     required: true,
              //     message: "กรุณาอัพโหลดไฟล์",
              //     className: "height-input-menu",
              //     valuePropName: "fileList",

              //   },
              // ],
            }
          )(
            <>
              {!record.disabledRow ? (
                <label
                  for={"input-file-" + arrayId}
                  className="custom-file-upload"
                  style={{ lineHeight: 1.5 }}
                >
                  <p
                    className="py-2 px-4 mb-0"
                    align={"center"}
                    style={{ backgroundColor: "#8d0e14", color: "#fff" }}
                  >
                    อัปโหลด
                  </p>
                  <p style={{ fontSize: "12px" }} className="my-2">
                    แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                  </p>
                </label>
              ) : (
                <label style={{ lineHeight: 1.5 }}>
                  <p
                    className="py-2 px-4 mb-0"
                    align={"center"}
                    style={{ backgroundColor: "#E3E3E3", color: "#fff" }}
                  >
                    อัปโหลด
                  </p>
                  <p style={{ fontSize: "12px" }} className="my-2">
                    แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                  </p>
                </label>
              )}
              <p
                className={fileName == "" && "color-red"}
                style={{ lineHeight: 1.2 }}
              >
                {fileName == "" && (
                  <p id={"showTextUplodas" + arrayId}>
                    กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์
                  </p>
                )}
              </p>
              <input
                id={"input-file-" + arrayId}
                className="input-file"
                // name={uploadName}
                type="file"
                accept="image/png, image/jpeg, application/pdf"
                onChange={(e) =>
                  this.handleAddUploadsFile(e.target.files, arrayId)
                }
                disabled={
                  this.props.isViewOnly
                    ? true
                    : record.disabledRow
                    ? true
                    : false
                }
              />
            </>
          )}
        </Form.Item>
      </>
    );
  };

  enableToEdit = async (arrayId, data) => {
    console.log("hi Edit Row");
    const { dataAttachInvoice } = this.state;
    const { form } = this.props;

    console.log("dataAttachInvoice enable", dataAttachInvoice);
    console.log("arrayId enable", arrayId);

    const mergeData = dataAttachInvoice.map((obj, _index) => ({
      ...obj,
      ...form.getFieldsValue()?.studyEducationFeeDetail[_index],
      isShowSaveButton:
        _index == arrayId ? true : obj.isValidate == false ? true : false,
      isShowEditButton:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      disabledRow:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      isValidate:
        _index == arrayId ? false : obj.isValidate == false ? false : true,
      //isNew: true,
    }));

    console.log("mergeData enable", mergeData);

    await this.setState({ dataAttachInvoice: mergeData });
    // setRow(mergeData);
    form.setFieldsValue({
      studyEducationFeeDetail: mergeData,
    });

    // await this.setSummaryTable()

    await this.setState({ disabledAdd: true });
  };

  setSummaryTable = async () => {
    const { form } = this.props;
    const { dataAttachInvoice, checkMoney, hospitalDetailValue } = this.state;

    let summaryStudyFeeDetailPrice = 0;
    let summaryStudyFeeDetailActualPrice = 0;

    await dataAttachInvoice.forEach(({ studyFeeDetailPrice }) => {
      if (studyFeeDetailPrice) {
        // summaryStudyFeeDetailPrice += parseFloat(studyFeeDetailPrice.replace(/,/g, ""));
        if (isFinite(String(studyFeeDetailPrice))) {
          summaryStudyFeeDetailPrice += parseFloat(studyFeeDetailPrice);
        } else {
          summaryStudyFeeDetailPrice += parseFloat(
            studyFeeDetailPrice.replace(/,/g, "")
          );
        }
      }
    });

    await dataAttachInvoice.forEach(({ studyFeeDetailActualPrice }) => {
      if (studyFeeDetailActualPrice) {
        // totalMoney += parseFloat(studyFeeDetailActualPrice.replace(/,/g, ""));
        if (isFinite(String(studyFeeDetailActualPrice))) {
          summaryStudyFeeDetailActualPrice += parseFloat(
            studyFeeDetailActualPrice
          );
        } else {
          summaryStudyFeeDetailActualPrice += parseFloat(
            studyFeeDetailActualPrice.replace(/,/g, "")
          );
        }
      }
    });

    await this.setState({
      summaryStudyFeeDetailPrice,
      summaryStudyFeeDetailActualPrice,
      edTotalActualPrice: numberWithCommas(summaryStudyFeeDetailActualPrice),
    });

    const fields = form.getFieldsValue();
    const { studyEducationFee } = fields;

    // await Object.assign(studyEducationFee,
    //    {
    //       studyEducationPrice: numberWithCommas(summaryStudyFeeDetailPrice),
    //       studyEducationActualPrice: numberWithCommas(summaryStudyFeeDetailActualPrice)
    //    }
    // )

    await form.setFieldsValue({
      studyEducationActualPrice: summaryStudyFeeDetailActualPrice,
    });
  };

  showDetailBtnInput = (record, arrayId, id) => {
    const { isViewOnly } = this.props;
    const { dataAttachInvoice } = this.state;
    // disabled={ this.props.isViewOnly }
    return (
      <>
        {console.log("arrayId show data", arrayId)}
        {record.isShowEditButton && (
          <Avatar
            shape="square"
            icon={<EditOutlined />}
            className="mr-2 mb-1"
            style={{
              cursor: (!isViewOnly && "pointer") || "no-drop",
              backgroundColor: !isViewOnly ? "#36699E" : "#CCC",
            }}
            onClick={() => !isViewOnly && this.enableToEdit(arrayId, record)}
          />
        )}
        {record.isShowSaveButton && (
          <Avatar
            shape="square"
            icon={<SaveOutlined />}
            className="mr-2 mb-1"
            style={{
              cursor: (!isViewOnly && "pointer") || "no-drop",
              backgroundColor: !isViewOnly ? "#36699E" : "#CCC",
            }}
            onClick={() => !isViewOnly && this.checkBeforeAddRow(arrayId)}
          />
        )}
        <Avatar
          shape="square"
          icon={<DeleteOutlined />}
          className={`mr-1 mb-1 ${!isViewOnly && "bg-red"}`}
          onClick={() => {
            !isViewOnly && this.destroyArrayDataUploads(arrayId, id, record);
          }}
          style={{
            cursor: (!isViewOnly && "pointer") || "no-drop",
            backgroundColor: !isViewOnly ? "#D7222A" : "#CCC",
          }}
        />
      </>
    );
  };
  destroyArrayDataUploads = async (arrayId, diasterAttachId = null, record) => {
    const { form, onChangeDeletedAttachment } = this.props;
    const { dataAttachInvoice } = this.state;
    var arrayDataSource = [...this.state.dataAttachInvoice];
    arrayDataSource.splice(arrayId, 1);

    //await this.hideModalConfirm();
    console.log("arrayDataSource before", arrayDataSource);
    console.log("destroyArray", arrayId);
    console.log("diasterAttachId", diasterAttachId);

    if (diasterAttachId) {
      console.log("record destroyArrayDataUploads", record);
      onChangeDeletedAttachment(record);
    }
    await this.setState(
      {
        dataAttachInvoice: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        //await this.props.onTableChange(arrayDataSource);
        let lengthData = arrayDataSource.length;
        await this.setState({
          dataTalbeLength: lengthData,
        });

        const fieldsBeforeMap = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord fieldsBefore map", fieldsBeforeMap);

        console.log("arrayDataSource.file", arrayDataSource);

        await this.props.form.setFieldsValue({
          studyEducationFeeDetail: arrayDataSource,
        });

        const fields = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord", fields);
        console.log("arrayDataSource after", arrayDataSource);
        let enableAddButton = true;
        arrayDataSource.map((resultObj, _index) => {
          console.log("resultObj.isValidate", resultObj.isValidate);
          if (!resultObj.isValidate) {
            console.log("HI resultObj.isValidate");
            enableAddButton = false;
            console.log("enableAddButton in", enableAddButton);
          }
        });

        if (enableAddButton) {
          await this.setState({ disabledAdd: false });
        } else {
          await this.setState({ disabledAdd: true });
        }
        await this.setSummaryTable();
      }
    );
  };

  dateFormatNumber = (values) => {
    const { form } = this.props;

    console.log("valueReturn values", values);
    let valueReturn = changeFormatdate(moment(form.getFieldValue(values)));
    console.log("valueReturn", valueReturn);

    return valueReturn;
  };

  onClickToNewTab2 = (dataFile, typeFile, arrayId) => {
    const { rawData } = this.props;
    //const { linkNewTab} = this.state
    console.log("onClickToNewTab2");
    console.log("onClickToNewTab2 typeFile", typeFile);

    if (typeFile !== "application/pdf") {
      console.log("onClickToNewTab2 non pdf");
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          "https://vtrcapi.redcross.or.th" +
          dataFile?.studyFeefilePath +
          '" style="height:100%"/></div>'
      );
    } else {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          "https://vtrcapi.redcross.or.th" +
          dataFile?.studyFeefilePath +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  // modalShowFileCreate2 = async (dataFile, title, arrayId) => {
  //   // var url = URL.createObjectURL(dataFile)

  //   console.log("DATAFILE VIEW", dataFile);

  //   console.log(
  //     "DATAFILE VIEW full",
  //     checkLinkURL() + dataFile.studyFeefilePath
  //   );
  //   console.log(
  //     "DATAFILE VIEW full /",
  //     "https://uat-vtrcapi.redcross.or.th" + dataFile.studyFeefilePath
  //   );

  //   const reader = new FileReader();
  //   if (dataFile.studyFeefileType !== "application/pdf") {
  //     //  reader.readAsDataURL(dataFile)
  //     //  reader.onloadend = async (e) => {
  //     //      var dataURL = reader.result;
  //     //      await this.setState({
  //     //          linkNewTab: dataURL
  //     //      })

  //     Modal.info({
  //       className: "modalFickIcons",
  //       title: "ไฟล์อัปโหลดเอกสารแนบ",
  //       width: "1000px",
  //       content: (
  //         <div>
  //           <hr></hr>
  //           <div className="mt-4">
  //             <Row gutter={16} type="flex" justify="left" align="top">
  //               <Col
  //                 span={10}
  //                 className="mb-3 block_show_file"
  //                 style={{ display: "block" }}
  //               >
  //                 <div
  //                   style={{
  //                     width: "100%",
  //                     height: "200px",
  //                     padding: "10px 55px",
  //                   }}
  //                   align="center"
  //                   className="block-show-image-modal"
  //                 >
  //                   <img
  //                     src={
  //                       "https://uat-vtrcapi.redcross.or.th" +
  //                       dataFile.studyFeefilePath
  //                     }
  //                     style={{ height: "100%" }}
  //                   />
  //                   <a
  //                     onClick={() =>
  //                       this.onClickToNewTab2(
  //                         dataFile,
  //                         dataFile.studyFeefileType,
  //                         arrayId
  //                       )
  //                     }
  //                     className="icons-show-images"
  //                   >
  //                     <Icon type="eye" style={{ color: "#fff" }} />
  //                   </a>
  //                 </div>
  //               </Col>
  //             </Row>
  //           </div>
  //         </div>
  //       ),
  //       okText: "ปิด",
  //       onOk() {},
  //     });
  //   } else {
  //     //  reader.readAsDataURL(dataFile)
  //     //  reader.onloadend = async (e) => {
  //     //      var dataURL = reader.result;
  //     //      await this.setState({
  //     //          linkNewTab: dataURL
  //     //      })

  //     Modal.info({
  //       className: "modalFickIcons",
  //       title: "ไฟล์อัปโหลดเอกสารแนบ",
  //       width: "1000px",
  //       content: (
  //         <div>
  //           <hr></hr>
  //           <div className="mt-4">
  //             <Row gutter={16} type="flex" justify="left" align="top">
  //               <Col
  //                 span={10}
  //                 className="mb-3 block_show_file"
  //                 style={{ display: "block" }}
  //               >
  //                 <div
  //                   style={{ width: "100%", height: "200px" }}
  //                   align="center"
  //                   className="block-show-image-modal"
  //                 >
  //                   <iframe
  //                     style={{ opacity: "0", height: "0" }}
  //                     style={{ display: "none" }}
  //                   ></iframe>
  //                   <a
  //                     onClick={() =>
  //                       this.onClickToNewTab2(
  //                         dataFile,
  //                         dataFile.studyFeefileType,
  //                         arrayId
  //                       )
  //                     }
  //                     className="color-white"
  //                   >
  //                     <Icon type="file-pdf" />
  //                     <br></br>
  //                     ดูไฟล์ PDF
  //                   </a>
  //                   <br></br>
  //                 </div>
  //               </Col>
  //             </Row>
  //           </div>
  //         </div>
  //       ),
  //       okText: "ปิด",
  //       onOk() {},
  //     });
  //   }
  // };

  // modalShowFileCreate3 = async (dataFile, title, arrayId) => {
  //   // var url = URL.createObjectURL(dataFile)

  //   console.log("DATAFILE VIEW", dataFile);

  //   console.log(
  //     "DATAFILE VIEW full",
  //     checkLinkURL() + dataFile.studyFeefilePath
  //   );
  //   console.log(
  //     "DATAFILE VIEW full /",
  //     "https://uat-vtrcapi.redcross.or.th" + dataFile.studyFeefilePath
  //   );

  //   const reader = new FileReader();
  //   if (dataFile.studyFeefileType !== "application/pdf") {
  //     //  reader.readAsDataURL(dataFile)
  //     //  reader.onloadend = async (e) => {
  //     //      var dataURL = reader.result;
  //     //      await this.setState({
  //     //          linkNewTab: dataURL
  //     //      })

  //     Modal.info({
  //       className: "modalFickIcons",
  //       title: "ไฟล์อัปโหลดเอกสารแนบ",
  //       width: "1000px",
  //       content: (
  //         <div>
  //           <hr></hr>
  //           <div className="mt-4">
  //             <Row gutter={16} type="flex" justify="left" align="top">
  //               <Col
  //                 span={10}
  //                 className="mb-3 block_show_file"
  //                 style={{ display: "block" }}
  //               >
  //                 <div
  //                   style={{
  //                     width: "100%",
  //                     height: "200px",
  //                     padding: "10px 55px",
  //                   }}
  //                   align="center"
  //                   className="block-show-image-modal"
  //                 >
  //                   <img
  //                     src={
  //                       "https://uat-vtrcapi.redcross.or.th" +
  //                       dataFile.studyFeefilePath
  //                     }
  //                     style={{ height: "100%" }}
  //                   />
  //                   <a
  //                     onClick={() =>
  //                       this.onClickToNewTab2(
  //                         dataFile,
  //                         dataFile.studyFeefileType,
  //                         arrayId
  //                       )
  //                     }
  //                     className="icons-show-images"
  //                   >
  //                     <Icon type="eye" style={{ color: "#fff" }} />
  //                   </a>
  //                 </div>
  //               </Col>
  //             </Row>
  //           </div>
  //         </div>
  //       ),
  //       okText: "ปิด",
  //       onOk() {},
  //     });
  //   } else {
  //     //  reader.readAsDataURL(dataFile)
  //     //  reader.onloadend = async (e) => {
  //     //      var dataURL = reader.result;
  //     //      await this.setState({
  //     //          linkNewTab: dataURL
  //     //      })

  //     Modal.info({
  //       className: "modalFickIcons",
  //       title: "ไฟล์อัปโหลดเอกสารแนบ",
  //       width: "1000px",
  //       content: (
  //         <div>
  //           <hr></hr>
  //           <div className="mt-4">
  //             <Row gutter={16} type="flex" justify="left" align="top">
  //               <Col
  //                 span={10}
  //                 className="mb-3 block_show_file"
  //                 style={{ display: "block" }}
  //               >
  //                 <div
  //                   style={{ width: "100%", height: "200px" }}
  //                   align="center"
  //                   className="block-show-image-modal"
  //                 >
  //                   <iframe
  //                     style={{ opacity: "0", height: "0" }}
  //                     style={{ display: "none" }}
  //                   ></iframe>
  //                   <a
  //                     onClick={() =>
  //                       this.onClickToNewTab2(
  //                         dataFile,
  //                         dataFile.studyFeefileType,
  //                         arrayId
  //                       )
  //                     }
  //                     className="color-white"
  //                   >
  //                     <Icon type="file-pdf" />
  //                     <br></br>
  //                     ดูไฟล์ PDF
  //                   </a>
  //                   <br></br>
  //                 </div>
  //               </Col>
  //             </Row>
  //           </div>
  //         </div>
  //       ),
  //       okText: "ปิด",
  //       onOk() {},
  //     });
  //   }
  // };

  ModalshowAllImageShow = async (data, title, arrayId, modalTypeUpload) => {
    console.log("data ModalshowAllImageShow", data);
    let dataArrayImage = data;
    let dataShowImage = [];
    // if(data[0].ModalShowImage){
    //    dataArrayImage = data.ModalShowImage
    // }

    dataArrayImage.map((resultObj, _index) => {
      if (resultObj.isDeleted != 1) {
        dataShowImage.push(resultObj);
      }
    });

    console.log("dataArrayImage", data);

    await this.setState({
      ModalshowAllImageVisible: true,
      ModalshowAllImageTitle: title,
      ModalshowAllImageData: dataShowImage,
      ModalshowAllImageArrayId: arrayId,
      ModalTypeUpload: modalTypeUpload,
    });
  };

  ModalshowAllImageHide = async () => {
    await this.setState({
      ModalshowAllImageVisible: false,
      ModalshowAllImageTitle: null,
      ModalshowAllImageData: [],
      ModalshowAllImageArrayId: null,
    });
  };

  showMoreFileUploads = (arrayId, uploadFile) => {
    const { formRef } = this.props;
    const { dataAttachInvoice, dataAttachInvoiceDocument, checkModal } =
      this.state;

    console.log("showMoreFileUploads" + arrayId);
    console.log("showMoreFileUploads uploadFile ddd", uploadFile);
    if (dataAttachInvoice[arrayId]?.studyEducationFeeAttachfile) {
      if (
        dataAttachInvoice[arrayId]?.studyEducationFeeAttachfile?.length !== 0
      ) {
        if (uploadFile?.studyFeefilePath) {
          console.log("showMoreFileUploads filepath");
          return (
            <p
              onClick={() => {
                this.ModalshowAllImageShow(uploadFile, "เอกสาร", arrayId);
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์เอกสารแนบ
            </p>
          );
        } else {
          console.log("showMoreFileUploads no studyfilepath");
          return (
            <p
              onClick={() => {
                this.ModalshowAllImageShow(uploadFile, "เอกสาร", arrayId);
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์เอกสารแนบ
            </p>
          );
        }
      }
    }
  };

  //   showMoreFileUploads = (arrayId, uploadFile) =>{
  //     const { formRef } = this.props
  //     const { dataAttachInvoice, dataTalbeUploadsDocument, checkModal } = this.state

  //     console.log("dataTalbeUploads showMoreFileUploads",dataAttachInvoice)
  //     if(dataAttachInvoice[arrayId]?.studyEducationFeeAttachfile){
  //        if(dataAttachInvoice[arrayId]?.studyEducationFeeAttachfile?.length !== 0){
  //        return (
  //           <>
  //             <p
  //               onClick={() => {
  //                 this.ModalshowAllImageShow(
  //                   dataAttachInvoice[arrayId].studyEducationFeeAttachfile,
  //                   "เอกสารแนบใบเสร็จ",
  //                   arrayId,
  //                   uploadFile
  //                 );
  //               }}
  //               style={{ cursor: "pointer" }}
  //               className="mb-0 btn-show-fileuploads"
  //             >
  //               ดูไฟล์อัปโหลด
  //             </p>
  //           </>
  //         );
  //     }
  //     }

  //  }

  handleAddRow = async () => {
    const { dataAttachInvoice, initialValue } = this.state;
    const { formRef, form } = this.props;

    const mergeData = dataAttachInvoice.map((obj, _index) => ({
      ...obj,
      ...form.getFieldsValue()?.studyEducationFeeDetail[_index],
      //   index: _index,
      //   studyReturnRound: _index + 1,
      disabledRow: obj.isValidate == false ? false : true,
      isShowEditButton: true,
      isShowSaveButton: false,
      isValidate: obj.isValidate == false ? false : true,
      //isNew: true,
    }));

    console.log("mergeData", mergeData);

    const result = [
      ...mergeData,
      {
        //index: dataTalbeExtend.length,
        //isNew: true,
        isShowEditButton: false,
        isShowSaveButton: true,
        isValidate: false,
        disabledRow: false,
        studyFeeDetailInvoiceNo: "",
        studyFeeDetailExpenses: "term_fee",
        studyFeeDetailDescription: "",
        studyFeeDetailSlipDate: null,
        studyFeeDetailPrice: 0.0,
        studyFeeDetailActualPrice: 0.0,
        studyEducationFeeAttachfile: [],
        studyFeeDetailType: "INVOICE",
        isDeleted: 0,
      },
    ];

    console.log("result handleadd", result);
    let enableAddButton = true;
    result.map((resultObj, _index) => {
      console.log("resultObj.isValidate", resultObj.isValidate);
      if (!resultObj.isValidate) {
        console.log("HI resultObj.isValidate");
        enableAddButton = false;
        console.log("enableAddButton in", enableAddButton);
      }
    });

    console.log("result add ", result);

    await this.setState({ dataAttachInvoice: result });

    form.setFieldsValue({
      studyEducationFeeDetail: result,
    });

    console.log("enableAddButton out", enableAddButton);

    if (enableAddButton) {
      await this.setState({ disabledAdd: false });
    } else {
      await this.setState({ disabledAdd: true });
    }
  };


  checkBeforeAddRow = async (arrayId) => {
    const { dataAttachInvoice, submitDateValue } = this.state;
    const { formRef, form } = this.props;
    console.log("checkBeforeAddRow arrayId", arrayId);

    const tableValue = dataAttachInvoice.map((obj, _index) => ({
      ...obj,
      ...form.getFieldsValue()?.studyEducationFeeDetail[_index],
    }));

    await this.setState({ disabledAdd: true });

    console.log("tableValue", tableValue);
    let lastRowValue = null;
    if (arrayId == "new") {
      console.log("arrayId = -1", arrayId);
      lastRowValue = tableValue[dataAttachInvoice.length - 1];
    } else {
      console.log("arrayId != -1");
      lastRowValue = tableValue[arrayId];
    }

    console.log("lastRowValue", lastRowValue);

    let errorValue = false;
    let dupDateError = false;
let dateSubmitSubtract = moment(submitDateValue)
  .subtract(1, 'year')
  .add(1, 'day')
  .startOf('day');


    if (
      lastRowValue.studyFeeDetailDescription == "" ||
      !lastRowValue.studyFeeDetailExpenses ||
      //lastRowValue.studyFeeDetailInvoiceNo == "" ||
      !lastRowValue.studyFeeDetailSlipDate ||
      lastRowValue.studyFeeDetailActualPrice == 0 ||
      lastRowValue.studyEducationFeeAttachfile.length == 0
    ) {
      errorValue = true;
      //TODO : specify empty field name in modal.error
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลเอกสารแนบใบเสร็จไม่สำเร็จ",
        width: "600px",
        content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
        okText: "ปิด",
        onOk() {},
      });

      
    } else if (
      moment(lastRowValue.studyFeeDetailSlipDate).isAfter(
        submitDateValue,
        "day"
      )
    ) {
      errorValue = true;
      //TODO : specify empty field name in modal.error
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลเอกสารแนบใบเสร็จไม่สำเร็จ",
        width: "600px",
        content: <h3 className="mt-3">ข้อมูลวันที่ใบเสร็จไม่ถูกต้อง</h3>,
        okText: "ปิด",
        onOk() {},
      });
      
    }  
    else if (
    moment(lastRowValue.studyFeeDetailSlipDate).isBefore(dateSubmitSubtract)
    ) {
      errorValue = true;
      //TODO : specify empty field name in modal.error
      Modal.error({
        className: "modalFickIcons",
        title: "เพิ่มข้อมูลเอกสารแนบใบเสร็จไม่สำเร็จ",
        width: "600px",
        content: <h3 className="mt-3">วันที่ในใบเสร็จอายุเกิน 1 ปี</h3>,
        okText: "ปิด",
        onOk() {},
      });
    }
    else {
      let arrayCheckDup = null;

      if (arrayId == "new") {
        arrayCheckDup = tableValue.slice(0, -1);
        console.log("table value slice", arrayCheckDup);
      } else {
        arrayCheckDup = tableValue;
      }

      arrayCheckDup.map((values, keys) => {
        console.log("keys", keys.toString());
        console.log("arrayId before checkdate", arrayId.toString());
console.log("arrayCheckDup", values);

        if (keys != arrayId && values.isValidate) {
          if (
            (lastRowValue.studyFeeDetailExpenses ==
            values.studyFeeDetailExpenses) &&
            (lastRowValue.studyFeeDetailInvoiceNo ==
            values.studyFeeDetailInvoiceNo) &&
             (moment(lastRowValue.studyFeeDetailSlipDate).format('YYYY-MM-DD') ==
            moment(values.studyFeeDetailSlipDate).format('YYYY-MM-DD')) &&
             (lastRowValue.studyFeeDetailSchool ==
            values.studyFeeDetailSchool) 
          ) {
            dupDateError = true;
          }
        }
      });

      if (dupDateError) {
        errorValue = true;
        //TODO : specify empty field name in modal.error
        Modal.error({
          className: "modalFickIcons",
          title: "เพิ่มข้อมูลเอกสารแนบใบเสร็จไม่สำเร็จ",
          width: "600px",
          content: <h3 className="mt-3">ไม่สามารถระบุเลขที่ใบเสร็จซ้ำ</h3>,
          okText: "ปิด",
          onOk() {},
        });
      }
    }
    if (!errorValue && !dupDateError) {
      if (arrayId == "new") {
        console.log("handleaddrow");
        this.handleAddRow();
      } else {
        console.log("handleEditRow");
        this.handleEditRow(arrayId);
      }
    }
  };

  handleEditRow = async (arrayId) => {
    const { dataAttachInvoice } = this.state;
    const { formRef, form } = this.props;

    const mergeData = dataAttachInvoice.map((obj, _index) => ({
      ...obj,
      ...form.getFieldsValue()?.studyEducationFeeDetail[_index],
      index: _index,
      // studyExtendRound: _index + 1,
      // studyExtendSort: _index + 1,
      disabledRow:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowEditButton:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      isShowSaveButton:
        _index == arrayId ? false : obj.isValidate == false ? true : false,
      isValidate:
        _index == arrayId ? true : obj.isValidate == false ? false : true,
      // isNew: true
    }));

    //console.log("row extend handle add", row);

    await this.setState({ dataAttachInvoice: mergeData });

    form.setFieldsValue({
      studyEducationFeeDetail: mergeData,
    });

    let enableAddButton = true;
    mergeData.map((resultObj, _index) => {
      if (!resultObj.isValidate) {
        enableAddButton = false;
      }
    });

    if (enableAddButton) {
      await this.setState({ disabledAdd: false });
    } else {
      await this.setState({ disabledAdd: true });
    }
    await this.setSummaryTable();
  };

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        var baseURL = reader.result.split("base64,");
        callback(baseURL[1]);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  onChangeSubmitDate = (value) => {
    const { dataTalbeUploads } = this.state;
    const { formRef } = this.props;

    console.log("value onChangeSubmitDate", value);

    this.setState({
      submitDateValue: value,
    });
  };

  getDropdownExpense = async () => {
  
  
    let config = {
      dropDownType: "expenseType",
      refCode: "",
    };
    const DataFetchAPI = await axiosAPI.post(
      `${checkLinkURL()}/getDropDownList`,
      config
    );


         console.log("DataFetchAPI history", DataFetchAPI);

         if (DataFetchAPI.data) {
            await this.setState({
               dropdownExpense: DataFetchAPI.data.data,
               //isEdit: DataFetchAPI.data.data.approveStatus == "draft" ? true : false,
            });
         } else {
         //   await this.setState({
         //       dropdownTumbol: [],
         //   });
         }
  };

  async componentDidMount() {
    const { rawData, dataAttachInvoiceData } = this.props;

    await this.getDropdownExpense()
    if (rawData) {
      this.setState({
        edTotalActualPrice: numberWithCommas(
          rawData?.studyEducationActualPrice
        ),
        submitDateValue: moment(rawData?.submitDate),
      });

      console.log("dataAttachInvoiceData", dataAttachInvoiceData);
      await dataAttachInvoiceData.map((values, keys) => {
        if (values.studyFeeDetailType == "INVOICE") {
          values.isValidate = true;
          values.isShowEditButton = true;
          values.disabledRow = true;
          values.isShowSaveButton = false;
        }

        values.studyFeeDetailSlipDate = moment(values.studyFeeDetailSlipDate);

        if (values.studyEducationFeeAttachfile?.length > 0) {
          values.studyEducationFeeAttachfile.map(
            async (valuesFile, keysFile) => {
              // console.log('checkLinkURL()+values.fileBase64', this.convertImgToBase64(checkLinkURL()+valuesFile.studyFeefilePath))
              await this.toDataURL(
                checkLinkURL() + valuesFile.studyFeefilePath,
                function (dataUrl) {
                  values.studyEducationFeeAttachfile[keysFile].base64 = dataUrl;
                }
              );
              values.studyEducationFeeAttachfile[keysFile].fileIdBase64 =
                valuesFile.studyFeeAttachmentId;
              values.studyEducationFeeAttachfile[keysFile].fileBase64 =
                valuesFile.studyFeefilePath;
              values.studyEducationFeeAttachfile[keysFile].fileMimeType =
                valuesFile.studyFeefileType;
            }
          );
        }
      });

      if (dataAttachInvoiceData?.length > 0) {
        this.setState({
          dataAttachInvoice: dataAttachInvoiceData,
        });
      }
    }
  }

  render() {
    const { match, rawData, isViewOnly, form } = this.props;
    const {
      loadingFullpage,
      columns,
      totalActualPrice,
      disabledAdd,
      dataAttachInvoice,
      edTotalActualPrice,
      ModalshowAllImageVisible,
      ModalshowAllImageTitle,
      ModalshowAllImageData,
      ModalshowAllImageArrayId,
    } = this.state;
    const { getFieldDecorator } = this.props.form;

    {
      console.log("ModalshowAllImageData", ModalshowAllImageData);
    }

    return (
      <>
        <ModalshowAllImageBase64
          title={ModalshowAllImageTitle}
          showModal={ModalshowAllImageVisible}
          data={ModalshowAllImageData}
          hideModal={this.ModalshowAllImageHide}
          dataArrayId={ModalshowAllImageArrayId}
          destroyArrayDataImages={this.destroyArrayDataImages}
          imageDatabase={false}
          //statusForm={statusForm}
        />
        {/* <Form
        //ref={this.formRef}
        >
           */}
        <Row gutter={16}>
          <Col md={24} className="mb-3">
            <Text className="color-red">
              <span style={{ fontSize: "18px" }}>
                ข้อมูลการเบิกค่าธรรมเนียมการศึกษา
              </span>
            </Text>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label="วันที่ยื่นเรื่อง" className="mb-0">
              {this.props.form.getFieldDecorator("submitDate", {
                initialValue: rawData?.submitDate
                  ? moment(rawData?.submitDate)
                  : null,
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ วันที่ยื่นเรื่อง",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={(current) => {
                    return moment() <= current;
                  }}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`submitDate`)}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  allowClear={false}
                  onChange={(e) => this.onChangeSubmitDate(e)}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label="ปีการศึกษา" className="mb-0">
              {this.props.form.getFieldDecorator("studyEducationFeeYear", {
                initialValue: rawData?.studyEducationFeeYear
                  ? rawData?.studyEducationFeeYear
                  : "",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ ปีการศึกษา",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ ปีการศึกษา"
                  disabled={isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label="ภาคการศึกษาที่" className="mb-0">
              {this.props.form.getFieldDecorator("studyEducationFeeTerm", {
                initialValue: rawData?.studyEducationFeeTerm
                  ? rawData?.studyEducationFeeTerm
                  : "",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ ภาคการศึกษาที่",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ ภาคการศึกษาที่"
                  disabled={isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Item label="ช่องทางการจ่ายเงิน" className="mb-0">
              {this.props.form.getFieldDecorator("paymentType", {
                initialValue: rawData?.paymentType ? rawData?.paymentType : "-",
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ ช่องทางการจ่ายเงิน",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ ช่องทางการจ่ายเงิน"
                  disabled={true}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={24} className="mb-2 mt-2">
          <Form.Item className="mb-0" valuePropName={"checked"}>
              {this.props.form.getFieldDecorator("isLoan", {
                initialValue: rawData?.isLoan == 1 ? true : false,
                rules: [
                  {
                    required: false,
                    message: "กรุณากรอกหรือเลือก ",
                  },
                ],
              })(
                <Checkbox
                  //checked={rawData?.isOtherPeople == 1 || rawData?.isOtherPeople ? true : false}
                  defaultChecked={
                    rawData?.isLoan == 1 || rawData?.isLoan
                      ? true
                      : false
                  }
                  disabled={isViewOnly}
                >
                เงินยืม :
                </Checkbox>
              )}
            </Form.Item>
            </Col> 
          <Col md={24} className="mb-2 mt-2">
            <Form.Item label={"ใบเสร็จ"} className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={dataAttachInvoice}
              pagination={false}
              scroll={{ x: "max-content" }}
            />
          </Col>

          <Col xs={24} md={24} align="right" style={{ textAlign: "right" }}>
            รวมยอดเงินที่เบิกได้จริง {edTotalActualPrice} บาท
            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator("studyEducationActualPrice", {
                initialValue: rawData?.studyEducationActualPrice
                  ? rawData?.studyEducationActualPrice
                  : 0,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ รายละเอียด",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ รายละเอียด"
                  disabled={this.props.isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <>
            <Col xs={14} md={12}>
              <ul
                style={{ listStyle: "none", textAlign: "left" }}
                className="p-0"
              >
                <li>
                  ** ต้องมีการกดปุ่มบันทึก แต่ละ record ก่อน
                  จึงจะสามารถเพิ่มข้อมูลหรือยื่นเรื่องได้
                </li>
              </ul>
            </Col>
            {
              !isViewOnly &&
              <Col xs={10} md={12} style={{ textAlign: "right" }}>
              <Button
                style={{ display: "inline-block" }}
                type="primary btn-color-default btn-clear"
                className="mt-1 mr-2"
                //onClick={() => this.showDataInputUploads()}
                onClick={() =>
                  dataAttachInvoice.lenght > 0
                    ? this.checkBeforeAddRow("new")
                    : this.handleAddRow()
                }
                disabled={disabledAdd ? true : false}
              >
                เพิ่มแถว
              </Button>
  }
            </Col>
            }
          </>

          {/*                       
            <Col xs={24} md={24} align="right" style={{ textAlign: "right" }}>
              {!isViewOnly && (
                <Button
                  style={{ display: "inline-block" }}
                  type="primary btn-color-default btn-clear"
                  className="mt-1 mr-2"
                  //onClick={() => this.showDataInputUploads()}
                  onClick={() =>
                    dataAttachInvoice.lenght > 0
                      ? this.checkBeforeAddRow("new")
                      : this.handleAddRow()
                  }
                  disabled={disabledAdd ? true : false}
                >
                  เพิ่มแถว
                </Button>
              )}
            </Col> */}
          {/* <Form.Item className="mb-0" hidden>
           {this.props.form.getFieldDecorator( "studyEducationActualPrice", {
             initialValue: rawData?.studyEducationActualPrice ? rawData?.studyEducationActualPrice : 0,
             rules: [
               {
                 required: false,
                 message: "กรุณาระบุ รายละเอียด",
               },
             ],
           })(
             <Input
               className="w-100"
               placeholder="ระบุ รายละเอียด"
               disabled={this.props.isViewOnly}
               allowClear={false}
             />
             
           )}
         </Form.Item> */}

          {/* 
           
          </Col>
          {/* <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={""}
              //required={true}
              name={"leaveTypeName"}
              label="จำนวนเงินในใบเสร็จทั้งหมด (บาท)"
              mode={"text"}
            />
          </Col>

          <Col md={12} className="mb-2">
            <FromInput
              disabled={true}
              value={""}
              //required={true}
              name={"leaveTypeName"}
              label="จำนวนเงินที่เบิกได้ทั้งหมด (บาท)"
              mode={"text"}
            />
          </Col> */}
          <Col md={24} className="mb-2">
            <Form.Item label={"หมายเหตุ"} className="mb-0">
              {this.props.form.getFieldDecorator("studyEducationRemark", {
                initialValue: rawData?.studyEducationRemark
                  ? rawData?.studyEducationRemark
                  : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ หมายเหตุ",
                  },
                ],
              })(
                <TextArea
                  // value={rawData?.disasterDetail ? rawData?.disasterDetail : "-"}
                  placeholder=""
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  disabled={isViewOnly}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        {/* </Form> */}
      </>
    );
  }
}

WelfareListStudyPaymentInPaymentDetail.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentInPaymentDetail.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentInPaymentDetail = Form.create()(
  WelfareListStudyPaymentInPaymentDetail
);

export default withApollo(WrappedWelfareListStudyPaymentInPaymentDetail);
